/**
 * ss-newsletter-popup.js — Join the Club
 * Desktop exit-intent only. Never interrupts age gate, cart drawer, or touch devices.
 */
(function () {
  'use strict';
  var el = document.querySelector('[data-ss-club]');
  if (!el) return;
  if (window.Shopify && window.Shopify.designMode) return;

  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    el.remove();
    return;
  }

  var COOKIE = 'ss_club_seen';
  var days = parseInt(el.getAttribute('data-cookie-days'), 10) || 14;
  var engageMs = (parseInt(el.getAttribute('data-engage'), 10) || 8) * 1000;
  var shown = false;
  var engaged = false;

  function getCookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return m ? m[1] : null;
  }
  function setCookie(name, value, d) {
    var exp = new Date();
    exp.setTime(exp.getTime() + d * 86400000);
    var secure = location.protocol === 'https:' ? ';Secure' : '';
    document.cookie = name + '=' + value + ';expires=' + exp.toUTCString() + ';path=/;SameSite=Lax' + secure;
  }

  if (getCookie(COOKIE) === '1') return;

  function siteBusy() {
    if (document.documentElement.classList.contains('ss-age-locked')) return true;
    if (document.documentElement.classList.contains('ss-age-pending') &&
        !document.documentElement.classList.contains('ss-age-verified')) return true;
    if (document.querySelector('cart-drawer.active')) return true;
    if (document.querySelector('.ss-qv.is-open')) return true;
    if (document.querySelector('.ss-search details[open]')) return true;
    if (document.body && document.body.classList.contains('ss-drawer-open')) return true;
    return false;
  }

  function open() {
    if (shown || !engaged || siteBusy()) return;
    shown = true;
    el.hidden = false;
    el.setAttribute('aria-hidden', 'false');
    document.body.classList.add('ss-club-open');
    setCookie(COOKIE, '1', days);
    var input = el.querySelector('input[type="email"]');
    if (input) setTimeout(function () { input.focus(); }, 220);
  }

  function close() {
    el.hidden = true;
    el.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('ss-club-open');
  }

  el.querySelectorAll('[data-ss-club-close]').forEach(function (btn) {
    btn.addEventListener('click', close);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !el.hidden) close();
  });

  setTimeout(function () { engaged = true; }, engageMs);

  document.addEventListener('mouseout', function (e) {
    if (!e.relatedTarget && !e.toElement && e.clientY < 8) open();
  });
})();
